import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth")({
  component: AuthLayout,
});

function AuthLayout() {
  return (
    <div className="flex justify-center flex-col gap-4 items-center h-screen w-screen mx-auto p-6">
      <Outlet />
    </div>
  );
}
